import React, { createContext, useContext, useState } from 'react';
import SwirlItModal from '../components/modals/SwirlItModal';

const SwirlModalContext = createContext();

export const useSwirlModal = () => {
  const context = useContext(SwirlModalContext);
  if (!context) {
    throw new Error('useSwirlModal must be used within a SwirlModalProvider');
  }
  return context;
};

export const SwirlModalProvider = ({ children }) => {
  const [showSwirlModal, setShowSwirlModal] = useState(false);
  const [onContentAdded, setOnContentAdded] = useState(null);

  const openSwirlModal = (callback) => {
    setOnContentAdded(() => callback);
    setShowSwirlModal(true);
  };

  const closeSwirlModal = () => {
    setShowSwirlModal(false);
    setOnContentAdded(null);
  };

  return (
    <SwirlModalContext.Provider value={{ openSwirlModal }}>
      {children}
      <SwirlItModal
        isOpen={showSwirlModal}
        onClose={closeSwirlModal}
        onContentAdded={onContentAdded}
      />
    </SwirlModalContext.Provider>
  );
};
